import { render, staticRenderFns } from "./sk-navbar-sidebar.vue?vue&type=template&id=772a3b6c"
import script from "./sk-navbar-sidebar.vue?vue&type=script&lang=js"
export * from "./sk-navbar-sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports